import React from 'react';
import { render } from 'react-dom';

import SponsorCarousel from '../react/SponsorCarousel';

export default class SponsorCarouselRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { model } = this.context.dataset;
    if (!model) throw Error('Missing a required dataset');
    const jsonModel = JSON.parse(model);

    render(<SponsorCarousel {...jsonModel} />, this.context);
  }
}
